/*jshint esversion: 6 */


const hamburgerMenu = document.getElementById("hamburgerMenu");
const hamburgerMenuDesktop = document.getElementById("hamburgerMenu-desktop");
const hamburgerCloseDesktop = document.getElementById("hamburgerMenu-close-desktop");
const mobileLoginMenu = document.getElementById("mobileLoginMenu");
const mainContent = document.getElementById("main");
const offCanvasMenu = document.getElementById("offCanvasMenu");
const offCanvasLogin = document.getElementById("offCanvasLogin");

function closeNav() {
    document.body.classList.remove("is-expanded");
    document.body.classList.remove("is-login-expanded");
    hamburgerMenu.setAttribute("aria-expanded", "false");
    if (mobileLoginMenu) mobileLoginMenu.setAttribute("aria-expanded", "false");
}

function openNav() {
    document.body.classList.add("is-expanded");
    hamburgerMenu.setAttribute("aria-expanded", "true");
}

function openLoginNav() {
    document.body.classList.add("is-expanded");
    document.body.classList.add("is-login-expanded");
    hamburgerMenu.setAttribute("aria-expanded", "true");
    mobileLoginMenu.setAttribute("aria-expanded", "true");
}

function toggleNav() {
    if (document.body.classList.contains("is-expanded")) {
        closeNav();
    } else {
        openNav();
    }
}

hamburgerMenu.addEventListener("click", () => {
    toggleNav();
}, false);

if (mobileLoginMenu)
    mobileLoginMenu.addEventListener("click", () => {
        if (document.body.classList.contains("is-login-expanded")) {
            closeNav();
        } else {
            closeNav();
            openLoginNav();
        }
    }, false);

if (hamburgerMenuDesktop)
    hamburgerMenuDesktop.addEventListener("click", () => {
        toggleNav();
    }, false);
if (hamburgerCloseDesktop)
    hamburgerCloseDesktop.addEventListener("click", () => {
        closeNav();
    }, false);

mainContent.addEventListener("click", (e) => {
    // Close mobile nav if click away from nav
    if (!offCanvasMenu.contains(e.target) &&
        !offCanvasLogin.contains(e.target) &&
        !hamburgerMenu.contains(e.target) &&
        (!mobileLoginMenu || !mobileLoginMenu.contains(e.target)) &&
        (!hamburgerMenuDesktop || !hamburgerMenuDesktop.contains(e.target))) {
        closeNav();
    }
}, true);

document.addEventListener("keyup", (e) => {
    // Close mobile nav if 'esc' is pressed
    if (e.keyCode === 27) {
        closeNav();
    }
}, true);
